import UserPersonaCollect from './UserPersonaCollect';

export default UserPersonaCollect;
